import {
  PatchWithMeta,
  PagedResponse,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { AnyAction } from "redux";
import { EventNotification } from "../domain/EventNotification";
import { ShareRecord } from "../domain/ShareRecord";
import { MODULE_NAME } from "../moduleName";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const LOADED_ITEMS = `${MODULE_NAME}/LOADED_ITEMS`;
export const LOADING_ITEMS = `${MODULE_NAME}/LOADING_ITEMS`;

export const LOADED_ITEM = `${MODULE_NAME}/LOADED_ITEM`;
export const LOADED_SHARE = `${MODULE_NAME}/LOADED_SHARE`;
export const LOADING_ITEM = `${MODULE_NAME}/LOADING_ITEM`;
export const SAVED_ITEM = `${MODULE_NAME}/SAVED_ITEM`;

export const UPDATING_ITEM = `${MODULE_NAME}/UPDATING_ITEM`;
export const UPDATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/UPDATING_ITEM_VALIDATION_FAIL`;

export const INPUTTING_ITEM = `${MODULE_NAME}/INPUTTING_ITEM`;
export const CREATING_ITEM = `${MODULE_NAME}/CREATING_ITEM`;
export const CREATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/CREATING_ITEM_VALIDATION_FAIL`;
export const CREATED_ITEM = `${MODULE_NAME}/CREATED_ITEM`;
export const CLOSING_ITEM = `${MODULE_NAME}/CLOSING_ITEM`;
export const ASSIGNING_ITEM = `${MODULE_NAME}/ASSIGNING_ITEM`;
export const SENDING_MESSAGE = `${MODULE_NAME}/SENDING_MESSAGE`;
export const SENDING_ATTACHMENTS = `${MODULE_NAME}/SENDING_ATTACHMENTS`;

export const UPDATING_SHARE = `${MODULE_NAME}/UPDATING_SHARE`;

export const loadedItems = (payload: PagedResponse<EventNotification>) => ({
  type: LOADED_ITEMS,
  payload,
});
export const loadingItems = (payload: QueryParams) => ({
  type: LOADING_ITEMS,
  payload,
});

export const loadedItem = (
  item: EventNotification,
  share?: ShareRecord | null
) => ({
  type: LOADED_ITEM,
  payload: { item, share },
});

export const loadedShare = (share: ShareRecord | null) => ({
  type: LOADED_SHARE,
  payload: share,
});

export const savedItem = (item: EventNotification) => ({
  type: SAVED_ITEM,
  payload: item,
});

export const loadingItem = (id: string) => ({
  type: LOADING_ITEM,
  payload: id,
});

export const updatingItem = (
  id: string,
  patchWithMeta: PatchWithMeta<EventNotification>,
  resourceTagsIds: number[]
) => ({
  type: UPDATING_ITEM,
  payload: { id, patchWithMeta, resourceTagsIds },
});

export const createItem = (item: EventNotification) => ({
  type: CREATING_ITEM,
  payload: item,
});

export const inputtingItem = () => ({
  type: INPUTTING_ITEM,
});

export const closeItem = (id: string, reason: string) => ({
  type: CLOSING_ITEM,
  payload: { id, isClose: true, reason },
});

export const reopenItem = (id: string) => ({
  type: CLOSING_ITEM,
  payload: { id, isClose: false },
});

export const assignItem = (
  id: string,
  assignedToUpn: string,
  assignedToDisplayName: string
) => ({
  type: ASSIGNING_ITEM,
  payload: { id, assignedToUpn, assignedToDisplayName },
});

export const sendMessage = (id: string, message: string) => ({
  type: SENDING_MESSAGE,
  payload: { id, message },
});

export const sendAttachments = (id: string, files: File[], note: string) => ({
  type: SENDING_ATTACHMENTS,
  payload: { id, files, note },
});

export const updatingShare = (id: string, share: ShareRecord) => ({
  type: UPDATING_SHARE,
  payload: { id, share },
});
